function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function _ts_values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
import AsyncStorage from "@react-native-async-storage/async-storage";
import * as Sentry from "@sentry/core";
// @ts-expect-error
import computeMd5 from "blueimp-md5";
import * as FileSystem from "expo-file-system/legacy";
import { createContext } from "react";
import { Platform } from "react-native";
import { v4 as uuid } from "uuid";
import { retry } from "@oui/lib/src/retry";
import { addBreadcrumb } from "./log";
import { GcsResumableUploader, SessionUri } from "./resumableUpload";
export { SessionUri };
var CANCELED_UPLOAD_URI = '__CANCELED__UPLOAD__';
var ASYNC_STORAGE_KEY = 'resumableUploadManagerData';
var DEFAULT_DATA = {
    pendingUploads: []
};
var MAX_UPLOADS_IN_FLIGHT = 4;
var getErrorStatus = function(error) {
    if ((typeof error === "undefined" ? "undefined" : _type_of(error)) !== 'object' || error === null || !('status' in error)) return undefined;
    return typeof error.status === 'number' ? error.status : undefined;
};
var withStatus = function(error, status) {
    return Object.assign(_instanceof(error, Error) ? error : new Error(String(error)), {
        status: status
    });
};
export var ResumableUploadManager = /*#__PURE__*/ function() {
    "use strict";
    function ResumableUploadManager(param) {
        var uploader = param.uploader, storage = param.storage, getBlob = param.getBlob;
        _class_call_check(this, ResumableUploadManager);
        _define_property(this, "cachedData", null);
        _define_property(this, "blobCache", {});
        _define_property(this, "uploadsInFlight", new Set());
        _define_property(this, "progressListeners", {});
        _define_property(this, "uploader", void 0);
        _define_property(this, "storage", void 0);
        _define_property(this, "refreshUriCallbacks", []);
        _define_property(this, "getBlob", void 0);
        this.uploader = uploader;
        this.storage = storage !== null && storage !== void 0 ? storage : AsyncStorage;
        this.getBlob = getBlob !== null && getBlob !== void 0 ? getBlob : /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(uri) {
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fetch(uri)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent().blob()
                            ];
                    }
                });
            });
            return function(uri) {
                return _ref.apply(this, arguments);
            };
        }();
    }
    _create_class(ResumableUploadManager, [
        {
            key: "registerUriRefreshCallback",
            value: function registerUriRefreshCallback(cb) {
                this.refreshUriCallbacks.push(cb);
            }
        },
        {
            key: "loadData",
            value: function loadData() {
                var _this = this;
                return _async_to_generator(function() {
                    var persistedData, tmpData;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.cachedData) return [
                                    2,
                                    _this.cachedData
                                ];
                                if (!(Platform.OS === 'web')) return [
                                    3,
                                    1
                                ];
                                _this.cachedData = DEFAULT_DATA;
                                return [
                                    3,
                                    3
                                ];
                            case 1:
                                return [
                                    4,
                                    _this.storage.getItem(ASYNC_STORAGE_KEY)
                                ];
                            case 2:
                                persistedData = _state.sent();
                                if (persistedData) {
                                    tmpData = JSON.parse(persistedData);
                                    _this.cachedData = {
                                        // migrate from potentially old stored data which didn't used to have ID
                                        pendingUploads: tmpData.pendingUploads.map(function(d) {
                                            var _d_ID;
                                            return _object_spread_props(_object_spread({}, d), {
                                                ID: (_d_ID = d.ID) !== null && _d_ID !== void 0 ? _d_ID : uuid()
                                            });
                                        })
                                    };
                                } else {
                                    _this.cachedData = DEFAULT_DATA;
                                }
                                _state.label = 3;
                            case 3:
                                return [
                                    2,
                                    _this.cachedData
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "saveData",
            value: function saveData(data) {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.cachedData = data;
                                if (!(Platform.OS !== 'web')) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.storage.setItem(ASYNC_STORAGE_KEY, JSON.stringify(data))
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSessionUri",
            value: function getSessionUri(ID) {
                var _this = this;
                return _async_to_generator(function() {
                    var data, uploadEntry;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.loadData()
                                ];
                            case 1:
                                data = _state.sent();
                                uploadEntry = data.pendingUploads.find(function(pending) {
                                    return pending.ID === ID;
                                });
                                return [
                                    2,
                                    uploadEntry === null || uploadEntry === void 0 ? void 0 : uploadEntry.sessionUri
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getBlobForUri",
            value: function getBlobForUri(uri) {
                var allowRecovery = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                var _this = this;
                return _async_to_generator(function() {
                    var cachedBlob, blob, e, data, pendingUpload, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, _ret, err, e1;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                cachedBlob = _this.blobCache[uri];
                                if (cachedBlob) return [
                                    2,
                                    cachedBlob
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    16
                                ]);
                                return [
                                    4,
                                    _this.getBlob(uri)
                                ];
                            case 2:
                                blob = _state.sent();
                                _this.blobCache[uri] = blob;
                                return [
                                    2,
                                    blob
                                ];
                            case 3:
                                e = _state.sent();
                                _state.label = 4;
                            case 4:
                                _state.trys.push([
                                    4,
                                    14,
                                    ,
                                    15
                                ]);
                                return [
                                    4,
                                    _this.loadData()
                                ];
                            case 5:
                                data = _state.sent();
                                pendingUpload = data.pendingUploads.find(function(u) {
                                    return u.sourceUri === uri;
                                });
                                Sentry.captureMessage('ResumableUploadManager.getBlobForUri refreshing uri', {
                                    extra: {
                                        data: data,
                                        uri: uri,
                                        pendingUpload: pendingUpload
                                    }
                                });
                                if (!(allowRecovery && pendingUpload)) return [
                                    3,
                                    13
                                ];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 6;
                            case 6:
                                _state.trys.push([
                                    6,
                                    11,
                                    12,
                                    13
                                ]);
                                _loop = function() {
                                    var refreshUriCallback, newUri, newData;
                                    return _ts_generator(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                refreshUriCallback = _step.value;
                                                return [
                                                    4,
                                                    refreshUriCallback(pendingUpload)
                                                ];
                                            case 1:
                                                newUri = _state.sent();
                                                if (!newUri) return [
                                                    3,
                                                    3
                                                ];
                                                newData = {
                                                    pendingUploads: data.pendingUploads.map(function(pending) {
                                                        return pending.sourceUri === uri ? _object_spread_props(_object_spread({}, pending), {
                                                            uri: newUri
                                                        }) : pending;
                                                    })
                                                };
                                                return [
                                                    4,
                                                    _this.saveData(newData)
                                                ];
                                            case 2:
                                                _state.sent();
                                                return [
                                                    2,
                                                    {
                                                        v: _this.getBlobForUri(newUri, false)
                                                    }
                                                ];
                                            case 3:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                };
                                _iterator = _this.refreshUriCallbacks[Symbol.iterator]();
                                _state.label = 7;
                            case 7:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    10
                                ];
                                return [
                                    5,
                                    _ts_values(_loop())
                                ];
                            case 8:
                                _ret = _state.sent();
                                if (_type_of(_ret) === "object") return [
                                    2,
                                    _ret.v
                                ];
                                _state.label = 9;
                            case 9:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    7
                                ];
                            case 10:
                                return [
                                    3,
                                    13
                                ];
                            case 11:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    13
                                ];
                            case 12:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 13:
                                return [
                                    3,
                                    15
                                ];
                            case 14:
                                e1 = _state.sent();
                                Sentry.captureException('ResumableUploadManager.getBlobForUri refreshing failed', {
                                    extra: {
                                        uri: uri,
                                        error: e1,
                                        cachedData: _this.cachedData
                                    }
                                });
                                return [
                                    3,
                                    15
                                ];
                            case 15:
                                Sentry.captureException('ResumableUploadManager.getBlobForUri failed', {
                                    extra: {
                                        uri: uri,
                                        error: e,
                                        cachedData: _this.cachedData
                                    }
                                });
                                throw withStatus(e, 400);
                            case 16:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "completeUpload",
            value: function completeUpload(ID) {
                var _this = this;
                return _async_to_generator(function() {
                    var data, matchingUpload, newData;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.loadData()
                                ];
                            case 1:
                                data = _state.sent();
                                matchingUpload = data.pendingUploads.find(function(u) {
                                    return u.ID === ID;
                                });
                                addBreadcrumb({
                                    category: 'resumableUploadManager',
                                    message: (matchingUpload === null || matchingUpload === void 0 ? void 0 : matchingUpload.sessionUri) === CANCELED_UPLOAD_URI ? 'canceledUpload' : 'completeUpload',
                                    data: {
                                        uploadsInFlight: _this.uploadsInFlight.size,
                                        MAX_UPLOADS_IN_FLIGHT: MAX_UPLOADS_IN_FLIGHT,
                                        ID: ID,
                                        pendingUploadsLength: data.pendingUploads.length
                                    }
                                });
                                _this.uploadsInFlight.delete(ID);
                                newData = {
                                    pendingUploads: data.pendingUploads.filter(function(pending) {
                                        return pending.ID !== ID;
                                    })
                                };
                                return [
                                    4,
                                    _this.saveData(newData)
                                ];
                            case 2:
                                _state.sent();
                                if (!(matchingUpload === null || matchingUpload === void 0 ? void 0 : matchingUpload.sourceUri.endsWith('.toupload'))) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    FileSystem.deleteAsync(matchingUpload === null || matchingUpload === void 0 ? void 0 : matchingUpload.sourceUri, {
                                        idempotent: true
                                    })
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                return [
                                    4,
                                    _this.startPendingUploads()
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getPendingUploadByCacheKey",
            value: function getPendingUploadByCacheKey(cacheKey) {
                var _this_cachedData;
                return (_this_cachedData = this.cachedData) === null || _this_cachedData === void 0 ? void 0 : _this_cachedData.pendingUploads.find(function(up) {
                    return up.cacheKey === cacheKey;
                });
            }
        },
        {
            key: "startUpload",
            value: function startUpload(ID, startByte) {
                var _this = this;
                return _async_to_generator(function() {
                    var _data_pendingUploads_find, _this_progressListeners_ID, sessionUri, _ref, isComplete, lastByte, data, uri, blob, _ref1, isComplete1, lastByte1, progressPayload;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                addBreadcrumb({
                                    category: 'resumableUploadManager',
                                    message: 'startUpload',
                                    data: {
                                        uploadsInFlight: _this.uploadsInFlight.size,
                                        MAX_UPLOADS_IN_FLIGHT: MAX_UPLOADS_IN_FLIGHT,
                                        ID: ID,
                                        startByte: startByte,
                                        isInFlightUri: _this.uploadsInFlight.has(ID)
                                    }
                                });
                                if (_this.uploadsInFlight.size >= MAX_UPLOADS_IN_FLIGHT && !_this.uploadsInFlight.has(ID)) return [
                                    2
                                ];
                                _this.uploadsInFlight.add(ID);
                                return [
                                    4,
                                    _this.getSessionUri(ID)
                                ];
                            case 1:
                                sessionUri = _state.sent();
                                if (!sessionUri) {
                                    Sentry.captureMessage('resumableUploadManager startUpload missing sessionUri', {
                                        extra: {
                                            uploadsInFlight: _this.uploadsInFlight.size,
                                            MAX_UPLOADS_IN_FLIGHT: MAX_UPLOADS_IN_FLIGHT,
                                            ID: ID,
                                            startByte: startByte,
                                            isInFlightUri: _this.uploadsInFlight.has(ID)
                                        }
                                    });
                                    return [
                                        2
                                    ];
                                }
                                if (sessionUri === CANCELED_UPLOAD_URI) {
                                    return [
                                        2,
                                        _this.completeUpload(ID)
                                    ];
                                }
                                if (!(typeof startByte !== 'number')) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    _this.uploader.checkResumableUpload(sessionUri)
                                ];
                            case 2:
                                _ref = _state.sent(), isComplete = _ref.isComplete, lastByte = _ref.lastByte;
                                if (!isComplete) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _this.completeUpload(ID)
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 4:
                                startByte = lastByte + 1;
                                _state.label = 5;
                            case 5:
                                return [
                                    4,
                                    _this.loadData()
                                ];
                            case 6:
                                data = _state.sent();
                                uri = (_data_pendingUploads_find = data.pendingUploads.find(function(u) {
                                    return u.ID === ID;
                                })) === null || _data_pendingUploads_find === void 0 ? void 0 : _data_pendingUploads_find.sourceUri;
                                if (!uri) {
                                    Sentry.captureMessage('resumableUploadManager startUpload missing sourceUri', {
                                        extra: {
                                            uploadsInFlight: _this.uploadsInFlight.size,
                                            MAX_UPLOADS_IN_FLIGHT: MAX_UPLOADS_IN_FLIGHT,
                                            ID: ID,
                                            startByte: startByte,
                                            isInFlightUri: _this.uploadsInFlight.has(ID)
                                        }
                                    });
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    _this.getBlobForUri(uri)
                                ];
                            case 7:
                                blob = _state.sent();
                                return [
                                    4,
                                    _this.uploader.uploadResumableChunk(sessionUri, blob, startByte)
                                ];
                            case 8:
                                _ref1 = _state.sent(), isComplete1 = _ref1.isComplete, lastByte1 = _ref1.lastByte;
                                progressPayload = isComplete1 ? {
                                    progress: blob.size,
                                    total: blob.size,
                                    percent: 100
                                } : {
                                    progress: lastByte1,
                                    total: blob.size,
                                    percent: Math.round(lastByte1 / blob.size * 100)
                                };
                                addBreadcrumb({
                                    category: 'resumableUploadManager',
                                    message: 'startUpload result',
                                    data: {
                                        uploadsInFlight: _this.uploadsInFlight.size,
                                        MAX_UPLOADS_IN_FLIGHT: MAX_UPLOADS_IN_FLIGHT,
                                        uri: uri,
                                        isComplete: isComplete1,
                                        startByte: startByte,
                                        lastByte: lastByte1,
                                        progressPayload: progressPayload
                                    }
                                });
                                (_this_progressListeners_ID = _this.progressListeners[ID]) === null || _this_progressListeners_ID === void 0 ? void 0 : _this_progressListeners_ID.forEach(function(cb) {
                                    return cb(progressPayload);
                                });
                                if (!isComplete1) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _this.completeUpload(ID)
                                ];
                            case 9:
                                _state.sent();
                                return [
                                    3,
                                    11
                                ];
                            case 10:
                                void _this.startUploadWithRetries(ID, lastByte1 + 1);
                                _state.label = 11;
                            case 11:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "startUploadWithRetries",
            value: function startUploadWithRetries(ID, startByte) {
                var _this = this;
                return _async_to_generator(function() {
                    var e;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    retry(/*#__PURE__*/ _async_to_generator(function() {
                                        var e, status, data;
                                        return _ts_generator(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    _state.trys.push([
                                                        0,
                                                        2,
                                                        ,
                                                        7
                                                    ]);
                                                    return [
                                                        4,
                                                        _this.startUpload(ID, startByte)
                                                    ];
                                                case 1:
                                                    return [
                                                        2,
                                                        _state.sent()
                                                    ];
                                                case 2:
                                                    e = _state.sent();
                                                    status = getErrorStatus(e);
                                                    if (!(status !== undefined && [
                                                        400,
                                                        401,
                                                        404
                                                    ].includes(status))) return [
                                                        3,
                                                        5
                                                    ];
                                                    Sentry.captureException(e, {
                                                        extra: {
                                                            ID: ID,
                                                            startByte: startByte
                                                        }
                                                    });
                                                    return [
                                                        4,
                                                        _this.loadData()
                                                    ];
                                                case 3:
                                                    data = _state.sent();
                                                    // TODO add callback for failed uploads
                                                    return [
                                                        4,
                                                        _this.saveData({
                                                            pendingUploads: data.pendingUploads.filter(function(pending) {
                                                                return pending.ID !== ID;
                                                            })
                                                        })
                                                    ];
                                                case 4:
                                                    _state.sent();
                                                    return [
                                                        3,
                                                        6
                                                    ];
                                                case 5:
                                                    throw e;
                                                case 6:
                                                    return [
                                                        3,
                                                        7
                                                    ];
                                                case 7:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    }), {
                                        timeout: 60000,
                                        logger: function(message) {
                                            Sentry.addBreadcrumb({
                                                message: 'startUploadWithRetries retry result',
                                                data: {
                                                    ID: ID,
                                                    startByte: startByte,
                                                    message: message
                                                }
                                            });
                                        },
                                        maxBackOff: process.env.NODE_ENV === 'test' ? 1 : undefined
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                e = _state.sent();
                                Sentry.captureException(e, {
                                    extra: {
                                        ID: ID,
                                        startByte: startByte
                                    }
                                });
                                Sentry.captureException('ResumableUploadManager error', {
                                    extra: {
                                        ID: ID,
                                        startByte: startByte,
                                        err: String(e)
                                    }
                                });
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "startPendingUploads",
            value: function startPendingUploads() {
                var _this = this;
                return _async_to_generator(function() {
                    var data, i, ID;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.loadData()
                                ];
                            case 1:
                                data = _state.sent();
                                for(i = 0; i < data.pendingUploads.length; i++){
                                    if (_this.uploadsInFlight.size >= MAX_UPLOADS_IN_FLIGHT) break;
                                    ID = data.pendingUploads[i].ID;
                                    if (_this.uploadsInFlight.has(ID)) continue;
                                    void _this.startUploadWithRetries(ID);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "addListener",
            value: function addListener(ID, callback) {
                var _this = this;
                var _this_progressListeners_ID;
                if (!this.progressListeners[ID]) {
                    this.progressListeners[ID] = [];
                }
                (_this_progressListeners_ID = this.progressListeners[ID]) === null || _this_progressListeners_ID === void 0 ? void 0 : _this_progressListeners_ID.push(callback);
                return function() {
                    var _this_progressListeners_ID;
                    var _this_progressListeners_ID_filter;
                    var remainingListeners = (_this_progressListeners_ID_filter = (_this_progressListeners_ID = _this.progressListeners[ID]) === null || _this_progressListeners_ID === void 0 ? void 0 : _this_progressListeners_ID.filter(function(l) {
                        return l !== callback;
                    })) !== null && _this_progressListeners_ID_filter !== void 0 ? _this_progressListeners_ID_filter : [];
                    if (remainingListeners.length) {
                        _this.progressListeners[ID] = remainingListeners;
                    } else {
                        delete _this.progressListeners[ID];
                    }
                };
            }
        },
        {
            key: "cancelUploadFile",
            value: function cancelUploadFile(uri) {
                var _this = this;
                return _async_to_generator(function() {
                    var data, newData;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.loadData()
                                ];
                            case 1:
                                data = _state.sent();
                                newData = {
                                    pendingUploads: data.pendingUploads.map(function(pending) {
                                        return pending.sourceUri === uri ? _object_spread_props(_object_spread({}, pending), {
                                            sessionUri: CANCELED_UPLOAD_URI
                                        }) : pending;
                                    })
                                };
                                return [
                                    4,
                                    _this.saveData(newData)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "uploadFile",
            value: function uploadFile(uri, sessionUri, cacheOptions) {
                var _this = this;
                return _async_to_generator(function() {
                    var fileName, blob, originalUri, _, ID, _tmp, data, e;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                fileName = uri.split('/').reverse()[0];
                                return [
                                    4,
                                    _this.getBlobForUri(uri)
                                ];
                            case 1:
                                blob = _state.sent();
                                if (!(Platform.OS === 'ios' && blob.type === 'image/jpeg')) return [
                                    3,
                                    4
                                ];
                                originalUri = uri;
                                // multiple files may have same filename but different path, we don't want those to clash
                                uri = "".concat(FileSystem.cacheDirectory, "resumableUploadManager-").concat(computeMd5(uri), "-").concat(fileName, ".toupload");
                                return [
                                    4,
                                    FileSystem.copyAsync({
                                        from: originalUri,
                                        to: uri
                                    })
                                ];
                            case 2:
                                _state.sent();
                                _ = Blob.bind;
                                return [
                                    4,
                                    _this.getBlobForUri(uri)
                                ];
                            case 3:
                                blob = new (_.apply(Blob, [
                                    void 0,
                                    [
                                        _state.sent()
                                    ],
                                    {
                                        type: 'image/jpeg'
                                    }
                                ]));
                                _state.label = 4;
                            case 4:
                                ID = uuid();
                                _state.label = 5;
                            case 5:
                                _state.trys.push([
                                    5,
                                    11,
                                    ,
                                    12
                                ]);
                                if (!(sessionUri !== null && sessionUri !== void 0)) return [
                                    3,
                                    6
                                ];
                                _tmp = sessionUri;
                                return [
                                    3,
                                    8
                                ];
                            case 6:
                                return [
                                    4,
                                    _this.uploader.initializeResumableUpload(blob, fileName)
                                ];
                            case 7:
                                _tmp = _state.sent();
                                _state.label = 8;
                            case 8:
                                sessionUri = _tmp;
                                return [
                                    4,
                                    _this.loadData()
                                ];
                            case 9:
                                data = _state.sent();
                                return [
                                    4,
                                    _this.saveData({
                                        pendingUploads: _to_consumable_array(data.pendingUploads).concat([
                                            {
                                                ID: ID,
                                                sourceUri: uri,
                                                sessionUri: sessionUri,
                                                cacheKey: cacheOptions === null || cacheOptions === void 0 ? void 0 : cacheOptions.cacheKey,
                                                metaData: cacheOptions === null || cacheOptions === void 0 ? void 0 : cacheOptions.metaData
                                            }
                                        ])
                                    })
                                ];
                            case 10:
                                _state.sent();
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                e = _state.sent();
                                Sentry.captureException(e);
                                throw e;
                            case 12:
                                void _this.startUploadWithRetries(ID, 0);
                                return [
                                    2,
                                    ID
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ResumableUploadManager;
}();
export var resumableUploadManager = new ResumableUploadManager({
    uploader: GcsResumableUploader
});
export var ResumableUploadManagerContext = createContext(resumableUploadManager);
